module.exports = __webpack_public_path__ + "img/active-3.4285089e.png";